'use strict';

/**
 * DateCard formatting via Intl.DateTimeFormat.
 *
 * Finds all `.contentCard__dateCard[datetime]` elements and formats the
 * ISO 8601 datetime attribute into a locale-aware short date (e.g. "Apr 15").
 */

/**
 * Formats a single date card element using the visitor locale.
 * @param {HTMLElement} el - Date card element with a `datetime` attribute.
 * @param {string} locale - BCP 47 locale string.
 * @private
 */
function _formatDateCard(el, locale) {
    let date = new Date(el.getAttribute('datetime'));
    if (isNaN(date.getTime())) return;

    el.textContent = new Intl.DateTimeFormat(locale, {
        month: 'short',
        day: 'numeric',
        timeZone: 'UTC',
    }).format(date);
}

/**
 * Initializes content card date formatting for all date cards on the page.
 */
export function initContentCardDate() {
    let dateCards = document.querySelectorAll(
        '.contentCard__dateCard[datetime]',
    );
    let locale = navigator.language || 'en-US';

    dateCards.forEach((el) => {
        _formatDateCard(el, locale);
    });
}
